import _defaultTo from 'lodash/defaultTo';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize, serialize } from 'serializr';
import { sourceSchema } from './schemas';
// Custom
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const serializerKey = 'source';

const deserializeSource = (data) => deserialize(sourceSchema, data);

const serializeSource = ({ name, type }) => ({
  [serializerKey]: {
    ...serialize(sourceSchema, {
      name: _defaultTo(name, null),
      type: _defaultTo(type, null),
    }),
  },
});

/**
* Lists
*/
const sourceTypesList = [
  {
    key: 'pushbutton',
    value: 'pushbutton',
    labelId: 'source.type.pushbutton',
    icon: 'stypePushBut',
  },
  {
    key: 'induction_loop',
    value: 'induction_loop',
    labelId: 'source.type.induction_loop',
    icon: 'stypeIndLoop',
  },
  {
    key: 'sensor',
    value: 'sensor',
    labelId: 'source.type.sensor',
    icon: 'stypeSensor',
  },
];

/**
* Utils
*/
const sortSources = (sources, fields = ['name', 'type'], dirs = ['asc', 'asc']) => (_orderBy(sources, fields, dirs));

const sourceTitle = (sourceData) => _get(sourceData, 'name', '');

const sourceType = (source) => findInList(sourceTypesList, 'value', source, 'type');

/**
* Model
*/
const source = {
  // Name
  name: 'source',

  // Serialization
  deserialize: deserializeSource,
  serialize: serializeSource,

  // Sort elements
  sortElements: sortSources,

  // Lists
  typesList: sourceTypesList,

  // Utils
  title: sourceTitle,
  type: sourceType,
};

module.exports = source;



// WEBPACK FOOTER //
// ./models/source.js